import { isBugsnagActive } from '@elevator/ui';
import bugsnagClient from './bugsnag';

/**
 * Options for error reporting/notification.
 */
export type NotifyOptions = Record<string, unknown>;

export function reportError(err: unknown, options?: NotifyOptions) {
  if (isBugsnagActive() && bugsnagClient) {
    (bugsnagClient as any).notify(err, options);
    return;
  }

  // Only log in local development. Jest uses NODE_ENV=test, which would
  // otherwise spam every test that intentionally renders error UI (LoadingError).
  if (process.env.NODE_ENV === 'development') {
    console.error(err);
  }
}
